export const getBase64 = (url?: string): Promise<string> => {
  return new Promise((resolve) => {
    if (!url) return "";
    const img = new Image();
    img.crossOrigin = "";
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx?.drawImage(img, 0, 0, img.width, img.height);
      const base64 = canvas.toDataURL("image/");
      resolve(base64);
    };
  });
};
